"use client";
import { useEffect } from "react";
import useFloatingContent from "@/app/lib/features/floatingContent/floatingContent.hook";
import AiButton from "./AiButton";
import PhoneButton from "./PhoneButton";
import LiveSupportButton from "./LiveSupportButton";
import SpinWheelButton from "./SpinWheelButton";
import WhatsAppButton from "./WhatsAppButton";
import { TooltipProvider } from "@/app/components/shadcn/tooltip";

interface FloatingActionButtonsProps {
  location?: "left" | "right";
}

const FloatingActionButtons = ({ location = "right" }: FloatingActionButtonsProps) => {
  const { floatingMenu, fetchFloatingContent, isLoading } =
    useFloatingContent();

  useEffect(() => {
    fetchFloatingContent();
  }, [fetchFloatingContent]);

  const filtered = floatingMenu.filter(
    (item) => item.is_active && (item.location ?? "right") === location,
  );

  if (isLoading && floatingMenu.length === 0) {
    return (
      <div className="flex flex-col gap-1.5 items-end justify-end">
        {[1, 2].map((i) => (
          <div
            key={i}
            className="w-10 sm:w-11 lg:w-12 h-10 sm:h-11 lg:h-12 rounded-xl bg-gray-200 animate-pulse shrink-0"
          />
        ))}
      </div>
    );
  }

  if (filtered.length === 0) return null;

  return (
    <TooltipProvider>
      <div className="flex flex-col gap-1.5 items-end justify-end">
        {filtered.map((item) => {
          if (item.key === "tozy") {
            return <AiButton key={item.key} item={item} />;
          }
          if (item.key === "app_promotion") {
            return <PhoneButton key={item.key} item={item} />;
          }
          if (item.key === "support") {
            return <LiveSupportButton key={item.key} item={item} />;
          }
          // if (item.key === "ai_call") {
          //   return <AiCallButton key={item.key} item={item} />;
          // }
          if (item.key === "lucky_wheel") {
            return <SpinWheelButton key={item.key} item={item} />;
          }
          if (item.key === "whatsapp") {
            return <WhatsAppButton key={item.key} item={item} />;
          }
          return null;
        })}
      </div>
    </TooltipProvider>
  );
};

export default FloatingActionButtons;